import { ApisauceInstance, create, ApisauceConfig } from 'apisauce';

import { ApiConfig, DEFAULT_API_CONFIG } from '../models';
import { getOidcUser, triggerSignin } from '../core/auth';

/**
 * Manages all requests to the API.
 */
export class Api {
  static apisauce: ApisauceInstance;

  setup(config: ApiConfig = DEFAULT_API_CONFIG) {
    const apiConfig: ApisauceConfig = {
      baseURL: config.baseUrl,
      headers: {
        Accept: 'application/json',
      },
    };

    Api.apisauce = create(apiConfig);

    Api.apisauce.addRequestTransform(request => {
      const accessToken = getOidcUser()?.access_token;
      if (accessToken) {
        request.headers.Authorization = `Bearer ${accessToken}`;
      } else {
        delete request.headers.Authorization;
      }
    });

    Api.apisauce.addResponseTransform(response => {
      if (response.status === 401) {
        triggerSignin();
      }
    });
  }
}
